import { isEmpty } from 'lodash';

export default function getSelectedTicketTypes(pageTicketGroups, formTicketGroups) {
  if (!pageTicketGroups || !pageTicketGroups.length) return [];
  if (!formTicketGroups || isEmpty(formTicketGroups)) return [];

  const ticketGroups = Object.keys(formTicketGroups)
    .map(ticketGroupId => {
      const ticketGroup = pageTicketGroups.find(group => group._id === ticketGroupId);

      if (!ticketGroup) return null;

      const formTicketGroup = formTicketGroups[ticketGroupId];

      const selectedTicketTypes = formTicketGroup
        .map(formTicketType => {
          const ticketType = ticketGroup.ticketTypes.find(
            type => type._id === formTicketType.ticketTypeId,
          );

          if (!ticketType) return null;

          if (formTicketType.quantity === 0) return null;

          return {
            ...ticketType,
            ticketGroup: ticketGroup._id,
            quantity: formTicketType.quantity,
          };
        })
        .filter(Boolean);

      return selectedTicketTypes;
    })
    .filter(Boolean);

  const selectedTicketTypes = ticketGroups.flat();

  return selectedTicketTypes;
}
